// extracted by mini-css-extract-plugin
module.exports = {"overflow":"RippleShapeOverflowFix-module--overflow--23Csi"};